// extracted by mini-css-extract-plugin
export default {"container":"OurProducts_container__CTp9k","cardcontainer":"OurProducts_cardcontainer__JHu+S"};